module.exports = __webpack_public_path__ + "img/核心技术--姿势估计.f12b825f.png";